import type {MetadataValidationResult} from 'schemas/types';
import type {
  ExpressionV4,
  ManifestationV4,
  MetadataEditConfiguration,
  MetadataEditState,
  WorkV4,
} from '../types';
import {validateMetadata} from './validateMetadata';

export const validateNewExpressionWithManifestation = ({
  savedWork,
  work,
  expression,
  savedManifestation,
  manifestation,
  configuration,
  statuses,
}: {
  savedWork: WorkV4;
  work: WorkV4;
  expression: ExpressionV4;
  savedManifestation: ManifestationV4;
  manifestation: ManifestationV4;
  configuration: MetadataEditConfiguration;
} & Pick<MetadataEditState, 'statuses'>): MetadataValidationResult => {
  return validateMetadata(
    {
      savedMetadata: {
        work: savedWork,
        expressions: [expression],
        manifestations: [savedManifestation],
        changeRequests: [],
      },
      metadata: {
        work,
        expressions: [expression],
        manifestations: [manifestation],
        changeRequests: [],
      },
      statuses,
    },
    configuration,
    {
      workId: work.id,
      expressions: [
        {
          expressionId: expression.id,
          manifestationIds: [manifestation.id],
        },
      ],
    },
  );
};
